import _ from "underscore";
import moment from 'moment';

export function QuickshopControllers() {

    function QuickShopCtrl($scope, reservationService, cartService, cacheService, settingsService) {

		$scope.categoryUrls = {
			5: 'bromma',
			7: 'arlanda',
			19: 'landvetter',
			20: 'malmo',
			70: 'skavsta',
			73: 'visby',
			74: 'vasteras',
			75: 'goteborg-city',
			76: 'viking-line',
            77: 'destination-gotland',
            78: 'tallink-silja',
		};

		var categories = {};
		$scope.airports = [];
		$scope.busLines = [];
		$scope.tickets = [];

		$scope.priceListLoaded = false;
		$scope.selectedAirport = null;
		$scope.selectedLine = null;
		$scope.selectedTicket = null;
		$scope.numberOfTickets = 1;


		$scope.init = function () {
			var localPriceList = reservationService.getLocalPriceList();
			if (localPriceList)
				updatePriceList(localPriceList);


			reservationService.loadPriceList()
				.then(updatePriceList, function (e) {
					alert('Det gick inte att hämta prislistan!\r\n\r\n' + e.data);
				});
		};

		function updatePriceList(priceList) {
			if (priceList && priceList.categories) {
				categories = _.chain(priceList.categories);
				$scope.airports = categories.map(function (c) { return { name: c.categoryName, id: c.categoryId, information: c.information }; }).value();

				var defaultLine = settingsService.get('Route');

				if (defaultLine) {
					cacheService.set('selectedLineId', defaultLine);
					var airport = categories.find(function (c) {
						return _(c.subcategories).some(function (sc) {
							return sc.subcategoryId === defaultLine;
						});
					}).value();
					if (airport)
						$scope.selectedAirport = _($scope.airports).findWhere({ id: airport.categoryId });

					if (!$scope.selectedAirport)
						$scope.selectedAirport = $scope.airports[0];
				}
				else {
					var selectedAirport = _($scope.airports).findWhere({ id: cacheService.get('selectedAirportId') });
					$scope.selectedAirport = selectedAirport ? selectedAirport : $scope.airports[0];
				}

				$scope.priceListLoaded = true;

			}
		}

		$scope.allowSelection = function (ticket) {
			var ticketRules = _(cartService.getTicketRules());

			if (ticketRules.contains('EJKOMB')) { //Biljetten i kundvagnen får ej kombineras med annan
				return ticket.id === cartService.cart.rows[0].ticket.id; //Ok att lägga till samma igen
			}

			if (_(ticket.rules).findWhere({ name: 'EJKOMB' })) { //Denna biljett får ej kombineras med andra
				return cartService.cart.rows.length == 0; //Får bara läggas till om kundvagnen är tom.
			}

			return true;
		};

		$scope.getRules = function (ticket) {
			return _(ticket.rules).reject(function (rule) { return rule.name === 'ALDER'; });
		};

		$scope.selectTicket = function (ticket) {
			$scope.selectedTicket = ticket;

			if (ticket)
				cacheService.set('selectedTicketId', ticket.id);
		};

		$scope.fewerTickets = function () {
			if ($scope.numberOfTickets > 1)
				$scope.numberOfTickets--;
		};

		$scope.moarTickets = function () {
			if ($scope.numberOfTickets < 100)
				$scope.numberOfTickets++;
		};

		$scope.addToCart = function () {
			cartService.addToCart($scope.selectedTicket, $scope.numberOfTickets);
			$scope.numberOfTickets = 1;
		};

		$scope.quickBuy = function () {
			cartService.clearCart();
			$scope.addToCart();

			$scope.$broadcast('quickBuy');
		};

		$scope.quickBuyDisabled = function () {
			return cartService.cart.rows.length > 0;
		};

		$scope.$watch('selectedAirport', function () {
			if (!$scope.selectedAirport || !categories)
				return;

			var subcategories = categories.findWhere({ categoryId: $scope.selectedAirport.id }).value().subcategories;

			$scope.busLines = _(subcategories).map(function (sc) {
				return {
					name: sc.subcategoryName,
					id: sc.subcategoryId,
					tickets: _(sc.tickets).map(function (t) {
						return {
							name: t.ticketName,
							type: t.ticketTypeName,
							//displayName: t.ticketGroup ? t.ticketName : t.ticketTypeName,
							displayName: t.ticketName + ' (' + t.ticketType +')',
							price: Math.round(t.priceExt * t.vatFactor),
							id: t.ticketId,
							rules: _(t.ticketRules).reject(function (rule) { return rule.name === 'ALDER'; })
						};
					})
				};
			});

			var selectedLine = _($scope.busLines).findWhere({ id: cacheService.get('selectedLineId') });
			$scope.selectedLine = selectedLine ? selectedLine : $scope.busLines[0];
			cacheService.set('selectedAirportId', $scope.selectedAirport.id);
		});

		$scope.$watch('selectedLine', function () {
			if (!$scope.selectedLine)
				return;

			$scope.tickets = $scope.selectedLine.tickets;
			var selectedTicket = _($scope.tickets).findWhere({ id: cacheService.get('selectedTicketId') });
			$scope.selectTicket(selectedTicket ? selectedTicket : null);
			cacheService.set('selectedLineId', $scope.selectedLine.id);
		});

		$scope.init();
	}

    function CartCtrl($scope, $location, $modal, $window, reservationService, cartService) {
		$scope.cart = cartService.cart;
		$scope.reservationInProgress = false;
		$scope.customerInfo = null;

		$scope.init = function () {
			$scope.requireCustomerInfo = window.QuickShopSettings.requireCustomerName;
		};

		$scope.totalPrice = function () {
			return _($scope.cart.rows).reduce(function (memo, row) {
				return memo + row.totalPrice;
			}, 0);
		};

		$scope.getRule = function (ruleName, ticket) {
			return _(ticket.rules).findWhere({
				name: ruleName
			});
		};

		$scope.showCustomerDialog = function () {
			var modalInstance = $modal.open({
				templateUrl: 'customerInfoModal',
				controller: ['$scope', '$modalInstance', 'cartService', customerInfoModalCtrl],
				backdrop: 'static'
			});

			modalInstance.result.then(function (customerInfo) {
				$scope.customerInfo = customerInfo;
				$scope.makeReservation();
			}, function () {
				alert('Du måste ange kunduppgifter för att kunna boka!');
			});
		};

		$scope.clearCart = function () {
			cartService.clearCart();
		};

		$scope.makeReservation = function () {
			if (!$scope.customerInfo && ($scope.requireCustomerInfo || _(cartService.getTicketRules()).contains('KUNDUPPG'))) {
				$scope.showCustomerDialog();
				return;
			}


			$scope.reservationInProgress = true;

			var spec = cartService.getReservationSpec($scope.customerInfo);

			$scope.customerInfo = null;

            reservationService.makeReservation(spec)
                .then(function (reservationResult) {
                    //console.debug(JSON.stringify(reservationResult));
                    switch (reservationResult.status) {
                    case 0:
                        cartService.clearCart();
                        $scope.reservationInProgress = false;
                        $location.path('/kvitto');
                        break;
                    case 1:
                        $window.location.href = reservationResult.redirectUrl;
                        $scope.reservationInProgress = false;
                        break;
                    case 2:
                        alert('Fel vid bokning!\r\n\r\n' + reservationResult.errorMessage);
                        $scope.reservationInProgress = false;
                        break;
                    }
				}, function (e) {
					alert('Det gick inte att boka!\r\n\r\n' + e.data);
					$scope.reservationInProgress = false;
				});
		};

		$scope.$on('quickBuy', function () {
			$scope.makeReservation();
		});

		$scope.init();
	}

	var customerInfoModalCtrl = function ($scope, $modalInstance, cartService) {
		$scope.customerInfo = {};
		$scope.ticketThatRequiresCustomerInfo = null;

		$scope.init = function () {
			var tickets = cartService.getTicketsWithRule('KUNDUPPG');
			if (tickets.length > 0)
                $scope.ticketThatRequiresCustomerInfo = tickets[0];
		};

		$scope.ok = function () {
			if (this.customerForm && this.customerForm.$invalid)
				return;

			$modalInstance.close($scope.customerInfo);
		};

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

		$scope.validateForm = function () {
			if (this.customerForm)
				this.customerForm.$setDirty();
		};

        $scope.showField = function (fieldName) {
            return !window.QuickShopSettings.fields.hasOwnProperty(fieldName) || window.QuickShopSettings.fields[fieldName].visible;
		}

		$scope.requireField = function (fieldName) {
			return $scope.showField(fieldName) && window.QuickShopSettings.fields.hasOwnProperty(fieldName) && window.QuickShopSettings.fields[fieldName].required;
		}

        $scope.hasError = function (field) {
			return this.customerForm && this.customerForm.$dirty && _(this.customerForm[field].$error).any(function (error) {
				return error;
			});
		};

		$scope.init();
	};

	function ShowReservationCtrl($scope, $window, $document, $timeout, $location, $modal, $routeParams, reservationService, settingsService) {
		$scope.reservation = null;

		$scope.init = function () {
			if ($routeParams.reservationId) {
				reservationService.loadReservation($routeParams.reservationId).then(
					function (reservation) {
						reservationService.addTicketInfoToReservation(reservation);
						$scope.reservation = reservation;
					},
					function (e) {
						alert('Det gick inte att hämta bokning.\r\n\r\n' + e.data);
					});
			} else {
				$scope.reservation = reservationService.getLastReservation();
				reservationService.addTicketInfoToReservation($scope.reservation);


				var image = $document[0].getElementById('aztecCode');
				function printIfImageLoaded() {
					if (image.complete) {
						//console.debug("Image complete, printing.");
						$window.print();
					} else {
						//console.debug("Image not complete yet, waiting 100 ms.");
						$timeout(printIfImageLoaded, 100);
					}

				}

				$timeout(printIfImageLoaded, 500);
			}

			$scope.printAsA4 = settingsService.get('ReceiptType') === 'A4';
		};

		$scope.cancelReservation = function () {
			var modalInstance = $modal.open({
				templateUrl: 'confirmationModal',
				controller: ['$scope', '$modalInstance', 'body', 'heading', confirmationModalCtrl],
				backdrop: 'static',
				resolve: {
					heading: function () { return 'Bekräfta'; },
					body: function () { return 'Är du säker på att du vill avboka denna bokning?'; }
				}
			});

			modalInstance.result.then(function (result) {
				reservationService.cancelReservation($scope.reservation.reservationId).then(
					function () {
						$location.path('/lista-bokningar');
					},
					function (e) {
						var reason;
						switch (e.status) {
							case 409:
								reason = "Det har redan använts biljetter på bokningen."; break;
							case 422:
								reason = "Det är för sent att avboka denna bokning."; break;
							default:
							    reason = "Okänt fel. [" + e.status + "]"; break;
						}
						alert('Det gick inte att avboka.\r\n\r\n' + reason);
					});
			});
		};

		$scope.init();
	}

	function cancelReservation(reservationService, reservationId, callback) {



	}

	function ReservationListCtrl($scope, $location, reservationService, appVariables) {
		$scope.reservations = [];
		$scope.appVariables = appVariables;
        $scope.sellerIds = window.QuickShopSettings.sellerIds;

		$scope.init = function () {
			reservationService.loadLatestReservations().then(
				function (result) {
					$scope.reservations = result;
					_($scope.reservations).forEach(function (r) { r.cssClass = r.cancellationTime ? 'cancelled' : ''; });
					$scope.$emit('finishedLoadingData', 'ReservationListCtrl');
				},
				function (e) {
					alert('Det gick inte att hämta bokningar.\r\n\r\n' + e.data);
				});
		};

		$scope.getReservationUrl = function (reservation) {
			return '/visa-bokning/' + reservation.reservationId;
		};

		$scope.showReservation = function (reservation) {
			$location.path($scope.getReservationUrl(reservation));
		};

		$scope.allowSearch = function () {
			return window.QuickShopSettings.allowSearch;
		};

		$scope.init();
	}

	function SearchReservationCtrl($scope, $location, reservationService, appVariables) {
		$scope.reservations = null;
		$scope.query = {};
		$scope.appVariables = appVariables;

		$scope.sellerIds = window.QuickShopSettings.sellerIds;

		$scope.init = function () {
			if (appVariables.lastSearch) {
				$scope.query = appVariables.lastSearch.query;
				$scope.reservations = appVariables.lastSearch.result;
			}


			appVariables.lastSearch = null;
		};

		$scope.search = function () {
			$scope.searchInProgress = true;
			$scope.reservations = [];

			reservationService.searchReservations($scope.query).then(
				function (hits) {
					$scope.reservations = hits;
					_($scope.reservations).forEach(function (r) { r.cssClass = r.cancellationTime ? 'cancelled' : ''; });
					$scope.searchInProgress = false;
				}, function (e) {
					$scope.searchInProgress = false;

					if (e.status === 403)
						alert('Ditt konto har inte möjlighet att söka efter bokningar.');
					else
						alert('Det gick inte att söka bokningar.');
				});
		};

		$scope.getReservationUrl = function (reservation) {
			return '/visa-bokning/' + reservation.reservationId;
		};

		$scope.showReservation = function (reservation) {
			appVariables.lastSearch = {
				query: $scope.query,
				result: $scope.reservations
			};

			$location.path($scope.getReservationUrl(reservation));
		};

		$scope.invalidModel = function () {
			return !($scope.query.reservationCode || $scope.query.customerName || $scope.query.reservationDate);
		};

		$scope.init();
	}

	function SettingsCtrl($scope, $timeout, settingsService) {
		$scope.clientName = null;
		$scope.receiptType = null;
		$scope.showSavedInfo = false;

		$scope.init = function () {
			$scope.clientName = settingsService.get('ClientName');
			$scope.receiptType = settingsService.get('ReceiptType') || "star";
		};

		$scope.saveSettings = function () {
			if ($scope.clientName) {
				settingsService.set('ClientName', $scope.clientName);
			}

			settingsService.set('ReceiptType', $scope.receiptType);
			$scope.showSavedInfo = true;
			$timeout(function () {
				$scope.showSavedInfo = false;
			}, 3000);
		};

		$scope.init();
	};

	var confirmationModalCtrl = function ($scope, $modalInstance, body, heading) {

		$scope.init = function () {
			$scope.body = body;
			$scope.heading = heading;
		};

		$scope.confirm = function () {
			$modalInstance.close('confirm');
		};

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

		$scope.init();
	};

	function SummaryReportCtrl($scope, $window, $location, $timeout, reportService) {
		$scope.report = null;
		$scope.loading = false;
		$scope.detailsUrl = null;

		$scope.sellers = [];

		$scope.startDate = null;
		$scope.endDate = null;
		$scope.sellerId = '';


		$scope.getReport = function () {
			$scope.loading = true;

			var startDate = moment($scope.startDate);
			var endDate = moment($scope.endDate);

			reportService.getSummaryReport(startDate, endDate, $scope.sellerId).then(function (result) {
				$scope.report = result;
				$scope.loading = false;

				$scope.detailsUrl = '#!/rapporter/detaljerad?from=' + startDate.format('YYYY-MM-DD') + '&to=' + endDate.format('YYYY-MM-DD');
				if ($scope.sellerId)
					$scope.detailsUrl += '&seller=' + $scope.sellerId;
			});
		}

		$scope.getExcelUrl = function () {
			return reportService.getSummaryReportUrl(moment($scope.startDate), moment($scope.endDate), $scope.sellerId, 'excel');
		}

		$scope.$watch('startDate', function (oldDate, newDate) {
			if (oldDate != newDate)
				$location.search('from', moment($scope.startDate).format('YYYY-MM-DD'));
		});

		$scope.$watch('endDate', function (oldDate, newDate) {
			if (oldDate != newDate)
				$location.search('to', moment($scope.endDate).format('YYYY-MM-DD'));				
		});

		$scope.$watch('sellerId', function (oldVal, newVal) {
			if (oldVal != newVal)
				$location.search('seller', $scope.sellerId);
		});

		$scope.init = function () {
			var sellerIds = $window.QuickShopSettings.sellerIds;
			if (sellerIds)
				$scope.sellers = sellerIds;


			var queryParams = $location.search();

			$scope.startDate = queryParams.from ? moment(queryParams.from).toDate() : moment().subtract(1, 'month').toDate();
			$scope.endDate = queryParams.to ? moment(queryParams.to).toDate() : moment().subtract(1, 'day').toDate();

			if (queryParams.seller)
				$scope.sellerId = queryParams.seller;

			$scope.getReport();
		}

		$scope.init();
	}

	function DetailedReportCtrl($scope, $window, $location, reportService) {
		$scope.sellers = [];

		$scope.startDate = null;
		$scope.endDate = null;
		$scope.sellerId = '';

		$scope.report = null;
		$scope.loading = false;
		$scope.reportType = 'sales';

		$scope.getReport = function () {
			$scope.loading = true;
			$scope.report = null;

			var startDate = moment($scope.startDate);
			var endDate = moment($scope.endDate);

			reportService.getDetailedReport(startDate, endDate, $scope.reportType, $scope.sellerId).then(function (result) {
				$scope.report = result;
				$scope.loading = false;

				$scope.summaryUrl = '#!/rapporter/?from=' + startDate.format('YYYY-MM-DD') + '&to=' + endDate.format('YYYY-MM-DD');
				if ($scope.sellerId)
					$scope.summaryUrl += '&seller=' + $scope.sellerId;
			});
		};

		$scope.switchReport = function () {
			$scope.reportType = $scope.reportType === 'sales' ? 'recalls' : 'sales';
			$scope.getReport();
		};

		$scope.$watch('startDate', function (oldDate, newDate) {
			if (oldDate != newDate)
				$location.search('from', moment($scope.startDate).format('YYYY-MM-DD'));
		});

		$scope.$watch('endDate', function (oldDate, newDate) {
			if (oldDate != newDate)
				$location.search('to', moment($scope.endDate).format('YYYY-MM-DD'));
		});

		$scope.$watch('sellerId', function (oldVal, newVal) {
			if (oldVal != newVal)
				$location.search('seller', $scope.sellerId);
		});

		$scope.init = function () {

		var sellerIds = $window.QuickShopSettings.sellerIds;
			if (sellerIds)
				$scope.sellers = sellerIds;

			var queryParams = $location.search();

			$scope.startDate = queryParams.from ? moment(queryParams.from).toDate() : moment().subtract(1, 'month').toDate();
			$scope.endDate = queryParams.to ? moment(queryParams.to).toDate() : moment().subtract(1, 'day').toDate();

			if (queryParams.seller)
				$scope.sellerId = queryParams.seller;

			

			$scope.getReport();
		};

		$scope.init();
	}

	return {
		quickShopCtrl: QuickShopCtrl,
		cartCtrl: CartCtrl,
		reservationListCtrl: ReservationListCtrl,
		searchReservationCtrl: SearchReservationCtrl,
		showReservationCtrl: ShowReservationCtrl,
		settingsCtrl: SettingsCtrl,
		summaryReportCtrl: SummaryReportCtrl,
		detailedReportCtrl: DetailedReportCtrl,
		customerInfoCtrl: customerInfoModalCtrl		
	};
};

